__turbopack_context__.v({
  "content": "SalesInfo-module__PvO_va__content",
  "promotionInfo": "SalesInfo-module__PvO_va__promotionInfo",
  "promotionInfoBanner": "SalesInfo-module__PvO_va__promotionInfoBanner",
  "promotionInfoButtons": "SalesInfo-module__PvO_va__promotionInfoButtons",
  "promotionInfoContent": "SalesInfo-module__PvO_va__promotionInfoContent",
  "promotionInfoDescription": "SalesInfo-module__PvO_va__promotionInfoDescription",
  "promotionInfoTitle": "SalesInfo-module__PvO_va__promotionInfoTitle",
  "showBlock": "SalesInfo-module__PvO_va__showBlock",
  "sortTypeSelectorSales": "SalesInfo-module__PvO_va__sortTypeSelectorSales",
});
